import { Injectable, InjectionToken, inject } from '@angular/core';

export const ENVIRONMENT_TOKEN = new InjectionToken<Environment>('Environment');

export interface Environment {
  production: boolean;
  useSessionToken: boolean;
  raDownloadURL: {
    windows: string;
    mac: string;
    ios: string;
    android: string;
  };
  sentry: {
    dsn: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService implements Environment {
  environment = inject<Environment>(ENVIRONMENT_TOKEN);

  get production() {
    return this.environment.production;
  }

  get useSessionToken() {
    return this.environment.production;
  }

  get sentry() {
    return this.environment.sentry;
  }

  get raDownloadURL() {
    return this.environment.raDownloadURL;
  }
}
